import { defineMessages, plural } from "../i18n/core";

export const overviewMessages = defineMessages({
  "pt-BR": {
    alerts: "Alertas",
    alertsSub: (n: number) => `${n} ${plural(n, "alerta aberto", "alertas abertos")}, mais graves primeiro`,
    alertSince: (when: string) => `aberto ${when}`,
    severityCritical: "Crítico",
    severityWarning: "Aviso",
    title: "Visão geral",
    agentsOnline: (online: number, total: number) => `${online} de ${total} agentes conectados agora.`,
    activity: "Atividade",
    addMachines: "Adicionar máquinas",
    protection: "Proteção",
    protectionSub: "Protegida: último backup dentro do RPO da política",
    protectedOf: (active: number) => `de ${active} ${plural(active, "máquina ativa protegida", "máquinas ativas protegidas")}`,
    attention: "Precisa de atenção",
    attentionSub: "Mais graves primeiro",
    allMachines: "Todas as máquinas",
    allProtected: "Todas as máquinas ativas estão protegidas.",
    lastBackup: (when: string) => `último backup ${when}`,
    noBackup: "nenhum backup concluído",
    open: "Abrir",
    recentActivity: "Atividade recente",
    viewAll: "Ver tudo",
    noActivity: "Nenhuma atividade ainda.",
    now: "agora",
    planUsage: "Uso do plano",
    details: "Detalhes",
    ofQuota: "da franquia",
    protectedAmount: (size: string) => `${size} protegidos`,
    ofTotal: (size: string) => `de ${size}`,
    storage: "Armazenamento",
    noStorage: "Nenhum volume contratado ainda.",
  },
  "en-US": {
    alerts: "Alerts",
    alertsSub: (n: number) => `${n} open ${plural(n, "alert", "alerts")}, most severe first`,
    alertSince: (when: string) => `opened ${when}`,
    severityCritical: "Critical",
    severityWarning: "Warning",
    title: "Overview",
    agentsOnline: (online: number, total: number) => `${online} of ${total} agents connected now.`,
    activity: "Activity",
    addMachines: "Add machines",
    protection: "Protection",
    protectionSub: "Protected: last backup within the policy RPO",
    protectedOf: (active: number) => `of ${active} active ${plural(active, "machine", "machines")} protected`,
    attention: "Needs attention",
    attentionSub: "Most severe first",
    allMachines: "All machines",
    allProtected: "All active machines are protected.",
    lastBackup: (when: string) => `last backup ${when}`,
    noBackup: "no completed backup",
    open: "Open",
    recentActivity: "Recent activity",
    viewAll: "View all",
    noActivity: "No activity yet.",
    now: "now",
    planUsage: "Plan usage",
    details: "Details",
    ofQuota: "of quota",
    protectedAmount: (size: string) => `${size} protected`,
    ofTotal: (size: string) => `of ${size}`,
    storage: "Storage",
    noStorage: "No volume contracted yet.",
  },
  es: {
    alerts: "Alertas",
    alertsSub: (n: number) => `${n} ${plural(n, "alerta abierta", "alertas abiertas")}, las más graves primero`,
    alertSince: (when: string) => `abierta ${when}`,
    severityCritical: "Crítica",
    severityWarning: "Aviso",
    title: "Resumen",
    agentsOnline: (online: number, total: number) => `${online} de ${total} agentes conectados ahora.`,
    activity: "Actividad",
    addMachines: "Agregar equipos",
    protection: "Protección",
    protectionSub: "Protegido: última copia dentro del RPO de la política",
    protectedOf: (active: number) => `de ${active} ${plural(active, "equipo activo protegido", "equipos activos protegidos")}`,
    attention: "Requiere atención",
    attentionSub: "Los más graves primero",
    allMachines: "Todos los equipos",
    allProtected: "Todos los equipos activos están protegidos.",
    lastBackup: (when: string) => `última copia ${when}`,
    noBackup: "ninguna copia completada",
    open: "Abrir",
    recentActivity: "Actividad reciente",
    viewAll: "Ver todo",
    noActivity: "Todavía no hay actividad.",
    now: "ahora",
    planUsage: "Uso del plan",
    details: "Detalles",
    ofQuota: "de la cuota",
    protectedAmount: (size: string) => `${size} protegidos`,
    ofTotal: (size: string) => `de ${size}`,
    storage: "Almacenamiento",
    noStorage: "Todavía no hay volumen contratado.",
  },
});
